/* RESPONSIBLE TEAM: team-email */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import type IntlService from 'embercom/services/intl';
import type InboundEmail from 'embercom/models/inbound-email';

type ModelParams = { email_id: number };

export default class InboundEmailRoute extends Route {
  @service declare store: Store;
  @service declare intl: IntlService;

  get titleToken(): string {
    return this.intl.t('app.templates.apps.app.inbound-email.title');
  }

  async model(params: ModelParams): Promise<InboundEmail | { hasAccessError: boolean }> {
    try {
      return await this.store.findRecord('inbound-email', params.email_id);
    } catch (error: unknown) {
      let status = (error as any)?.jqXHR?.status;

      if (status === 403) {
        return { hasAccessError: true };
      }

      // Re-throw other errors to be handled by Ember's error handling
      throw error;
    }
  }

  setupController(
    controller: any,
    model: InboundEmail | { hasAccessError: boolean },
    transition?: any,
  ): void {
    super.setupController(controller, model, transition);

    if ('hasAccessError' in model) {
      controller.hasAccessError = true;
      controller.model = null;
    } else {
      controller.hasAccessError = false;
      controller.model = model;
    }
  }
}
